export default {
  casino: [
    {
      name: "AI Gaming",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/casino?suite=10",
      popup: "window.open(this.href,'casino10','top=10,height=800,width=450,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/casino-ai.png?v=4",
      title: "ui.ai_casino",
      exclude: [],
      currency: []
    },
    {
      name: "Pragmatic",
      isHidden: true,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/casino?suite=9",
      popup: "window.open(this.href,'casino9','top=10,height=500,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/casino-pragmatic.png?v=4",
      title: "ui.london_suite",
      exclude: [],
      currency: []
    },
    {
      name: "Yee Bet",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/casino?suite=8",
      popup: "window.open(this.href,'casino8','top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/casino-yeebet.png?v=4",
      title: "ui.yeebet_suite",
      exclude: [],
      currency: []
    },
    {
      name: "CT855",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/casino?suite=4",
      popup: "window.open(this.href,'casino4','top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/casino-ct855.png?v=4",
      title: "ui.vietnam_suite",
      exclude: ['IBCBET'],
      currency: []
    },
    {
      name: "Gameplay",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/casino?suite=1",
      popup: "window.open(this.href,'casino1','top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/casino-gameplay.png?v=4",
      title: "ui.manila_suite",
      exclude: [],
      currency: []
    },
    {
      name: "SA Gaming",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/casino?suite=3",
      popup: "window.open(this.href,'casino3','top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/casino-sagaming.png?v=4",
      title: "ui.bangkok_suite",
      exclude: ['IBCBET'],
      currency: []
    },
    {
      name: "Evolution",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/casino?suite=5",
      popup: "window.open(this.href,'casino5','top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/casino-evo.png?v=4",
      title: "ui.vegas_suite",
      exclude: ['IBCBET'],
      currency: []
    },
    {
      name: "Pretty Gaming",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/casino?suite=7",
      popup: "window.open(this.href,'casino7','top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/casino-pretty-gaming.png?v=4",
      title: "ui.phnom_penh_suite",
      exclude: [],
      currency: []
    },
  ],
  slots: [
    {
      name: "EpicWin",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/slots14",
      popup: "window.open(this.href,'slots14','top=10,height=594,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/slot-epicwin.png?v=4",
      title: "ui.epicwin",
      exclude: [],
      currency: ['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK']
    },
    {
      name: "WOW Gaming",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/slots11",
      popup: "window.open(this.href,'slots11','top=10,height=800,width=480,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/slot-wow.png?v=4",
      title: "ui.wow_gaming",
      exclude: [],
      currency: ['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK']
    },
    {
      name: "Live22",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/slots12",
      popup: "window.open(this.href,'slots12','top=10,height=594,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/slot-live22.png?v=4",
      title: "ui.live22",
      exclude: [],
      currency: ['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK']
    },
    {
      name: "WF Gaming",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/slots13",
      popup: "window.open(this.href,'slots13','top=10,height=594,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/slot-wf.png?v=4",
      title: "ui.wf_gaming",
      exclude: [],
      currency: ['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK']
    },
    {
      name: "DBHASH",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/slots9",
      popup: "window.open(this.href,'slots9','top=10,height=800,width=480,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/slot-dbhash.png?v=4",
      title: "ui.dbhash",
      exclude: [],
      currency:  ['CNY','THB', 'MYR', 'USD', 'SGD']
    },
    {
      name: "UUSL",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/slots7",
      popup: "window.open(this.href,'slots7','top=10,height=658,width=1200,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/slot-uuslots.png?v=4",
      title: "ui.uusl",
      exclude: [],
      currency: ['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK', 'VND']
    },
    {
      name: "NEXTSPIN",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/slots8",
      popup: "window.open(this.href,'slots8','top=10,height=658,width=1200,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/slot-nextspin.png?v=4",
      title: "ui.nextspin",
      exclude: [],
      currency: ['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'MMK']
    },
    {
      name: "Pragmatic",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/slots3",
      popup: "window.open(this.href,'slots3','top=10,height=658,width=1024,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/slot-pragmatic.png?v=4",
      title: "ui.pragmatic",
      exclude: [],
      currency:  ['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'VND']
    },
    {
      name: "Joker",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/slots4",
      popup: "window.open(this.href,'slots4','top=10,height=658,width=1024,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/slot-joker.png?v=4",
      title: "ui.joker",
      exclude: [],
      currency: ['CNY', 'IDR', 'THB', 'MYR', 'USD']
    },
    {
      name: "PG Soft",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/slots8",
      popup: "window.open(this.href,'slots2','top=10,height=640,width=360,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/slot-pgsoft.png?v=4",
      title: "ui.pgs",
      exclude: [],
      currency: ['CNY', 'MMK', 'IDR', 'THB', 'VND', 'KRW', 'USD']
    },
    {
      name: "Simple Play",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/slots5",
      popup: "window.open(this.href,'slots5','top=10,height=528,width=1024,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/slot-simpleplay.png?v=4",
      title: "ui.simpleplay",
      exclude: [],
      currency: ['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'VND']
    },
    {
      name: "JILI",
      isHidden: false,
      isSupportMMO: false,
      isNewFeatures: false,
      toPath: "/slots6",
      popup: "window.open(this.href,'slots6','top=10,height=512,width=1093,status=no,toolbar=no,menubar=no,location=no');return false;",
      thumbnail: "/img/lobby/slot-jili.png?v=4",
      title: "ui.jili",
      exclude: [],
      currency: ['THB', 'MYR', 'USD']
    },
  ]
};
